import "react";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Box as n, FlexBox as r, Icon as i, Page as a, Text as o } from "@dixa/lib-shared-habla";
import s from "classnames";
import { Link as c } from "react-router-dom";
var l = {
	root: "_root_vjca1_2",
	slotLeft: "_slotLeft_vjca1_11",
	slotCenter: "_slotCenter_vjca1_12",
	slotRight: "_slotRight_vjca1_13",
	head: "_head_vjca1_35",
	controls: "_controls_vjca1_83",
	link: "_link_vjca1_90",
	linkArrow: "_linkArrow_vjca1_106",
	body: "_body_vjca1_112",
	hablaPageBody: "_hablaPageBody_vjca1_122"
};
//#endregion
//#region ../utils/src/components/page/head.tsx
function u({ title: t }) {
	return /* @__PURE__ */ e(o.Heading, {
		variant: "heading-2",
		as: "h1",
		"data-testid": "main-heading",
		children: t
	});
}
function d({ subtitle: t }) {
	return /* @__PURE__ */ e(o.Paragraph, {
		variant: "4",
		subdued: !0,
		children: t
	});
}
var f = ({ backProps: n, backText: r }) => /* @__PURE__ */ t(c, {
	className: l.link,
	...n,
	children: [/* @__PURE__ */ e(i, {
		name: "angle-left",
		className: l.linkArrow
	}), r]
}), p = ({ title: i, subtitle: a, className: o }) => a ? /* @__PURE__ */ t(r, {
	className: o,
	flexDirection: "column",
	children: [/* @__PURE__ */ e(r, {
		alignItems: "center",
		children: /* @__PURE__ */ e(u, { title: i })
	}), /* @__PURE__ */ e(n, { children: /* @__PURE__ */ e(d, { subtitle: a }) })]
}) : /* @__PURE__ */ e(r, {
	className: o,
	alignItems: "center",
	children: /* @__PURE__ */ e(u, { title: i })
}), m = ({ className: r, slotCenter: i, slotLeft: a, slotRight: o, children: c }) => /* @__PURE__ */ t("div", {
	className: r,
	id: "pageHead",
	children: [/* @__PURE__ */ t("div", {
		className: s("pageHead", l.head),
		children: [
			!!a && /* @__PURE__ */ e(n, {
				className: l.slotLeft,
				children: a
			}),
			!!i && /* @__PURE__ */ e(n, {
				className: l.slotCenter,
				children: i
			}),
			!!o && /* @__PURE__ */ e(n, {
				className: l.slotRight,
				children: o
			})
		]
	}), c && /* @__PURE__ */ e("div", { children: c })]
}), h = ({ className: t, children: n, flexDirection: r, ...i }) => /* @__PURE__ */ e("div", {
	className: s(l.root, t),
	...i,
	children: n
});
h.Body = ({ children: t, padding: n, flexDirection: r, ...i }) => /* @__PURE__ */ e(a.Body, {
	className: l.hablaPageBody,
	...i,
	children: t
}), h.Head = m, h.HeadTitle = p, h.HeadBackLink = f, h.Section = a.Section, h.Tabs = a.Tabs;
//#endregion
//#region ../utils/src/components/page/index.tsx
var g = h;
//#endregion
export { g as t };

//# sourceMappingURL=page-C_DmF7B-.js.map